import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBlueEgg = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 70,
	fill: "none",
	viewBox: "0 0 60 70",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "M53.4 41.05c-2.74 15.51-11.55 27.17-30.54 23.82C7.4 62.14 2.26 48.03 4.99 32.52 7.73 17.02 25.97 2.69 34.93 4.27c9.92 1.75 21.2 21.28 18.46 36.78Z"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_15495_223056",
			width: 50,
			height: 62,
			x: 4,
			y: 4,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#18A0FB",
				d: "M53.4 41.05c-2.74 15.51-11.55 27.17-30.54 23.82C7.4 62.14 2.26 48.03 4.99 32.52 7.73 17.02 25.97 2.69 34.93 4.27c9.92 1.75 21.2 21.28 18.46 36.78Z"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#FDC564",
			mask: "url(#mask0_15495_223056)",
			children: [/* @__PURE__ */ _jsx("path", { d: "M11.55 36.54a12.12 12.12 0 0 0-6.45-5.9l-1.06 6c4.97 2.02 6.4 4.64 6.49 5.7 1.01-1.12 4.22-3.28 8.9-2.98 5.86.37 7.82 7.34 8.06 5.96.25-1.37 4.7-4.04 9-3.28 4.17.74 7.33 4.68 8.5 6.8.96-2.46 6.26-3.45 8.76-3.43l1.06-6.01c-4.15-1.94-7.55 1.34-8.73 3.22-5.81-9.86-14.13-6.17-17.56-3.1-5.84-9.69-13.75-6.03-16.97-2.98Z" }), /* @__PURE__ */ _jsx("path", { d: "M9.94 46.94a12.12 12.12 0 0 0-6.45-5.9l-1.06 6.01c4.97 2.02 6.4 4.64 6.49 5.7 1.02-1.12 4.22-3.28 8.9-2.99 5.86.37 7.83 7.34 8.07 5.97.24-1.37 4.7-4.04 8.99-3.28 4.17.73 7.33 4.67 8.5 6.8.96-2.47 6.27-3.45 8.76-3.43l1.06-6.02c-4.15-1.93-7.55 1.35-8.73 3.23-5.8-9.86-14.13-6.17-17.56-3.1-5.84-9.69-13.75-6.03-16.97-2.99Z" })]
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_15495_223056",
			width: 50,
			height: 62,
			x: 4,
			y: 4,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#18A0FB",
				d: "M53.4 41.05c-2.74 15.51-11.55 27.17-30.54 23.82C7.4 62.14 2.26 48.03 4.99 32.52 7.73 17.02 25.97 2.69 34.93 4.27c9.92 1.75 21.2 21.28 18.46 36.78Z"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_15495_223056)",
			children: /* @__PURE__ */ _jsx("path", {
				fill: "#000",
				fillOpacity: .07,
				d: "M33.45 67.36c3.5-1.37 12.47-.19.32-1.82-14.01-1.88-26.47-12.27-26.52-42-14.21 36.7 12.02 45.1 26.2 43.82Z"
			})
		})
	]
});
export default SvgBlueEgg;
